import { fullBlockerClassName } from '@/features/session-tutorial/sessionTutorial.styles';
import { SESSION_TUTORIAL_UI_ATTRIBUTE } from '@/features/session-tutorial/useInertOutside';
import { createPortal } from 'react-dom';

/** Dims the page while the sample plays or its note is written (nothing to point at; the page is inert). */
export const SessionTutorialBlocker = () =>
  createPortal(
    <div
      aria-hidden
      {...{ [SESSION_TUTORIAL_UI_ATTRIBUTE]: '' }}
      data-testid="session-tutorial-dim"
      className={fullBlockerClassName}
    />,
    document.body
  );
